<template>
	<div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Document</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
	        <form class="p-6 divide-y divide-gray-200">
		    	<div class="flex py-4">
		    		<div class="w-1/3">
			    		<label class="text-base" for="name">Name</label>
			    	</div>
			    	<div class="flex-1">
						<input type="text" name="name" class="form-input w-full" v-model="document.name" size="30">
			    	</div>
			    </div>
		    	<div class="flex py-4">
		    		<div class="w-1/3">
			    		<label class="text-base" for="description">Description</label>
			    	</div>
			    	<div class="flex-1">
						<textarea class="form-textarea" name="description" rows="5" cols="50" v-model="document.description" :v-text="document.description"></textarea>
			    	</div>
			    </div>
		    	<div class="flex py-4">
		    		<div class="w-1/3">
			    		<label class="text-base" for="category_id">Categories</label>
			    	</div>
			    	<div class="flex-1">
			    		<div class="flex">
			    			<div class="flex flex-col mr-4">
			    				<label class="mb-2" for="category_id">Category</label>
								<select class="mt-0 form-select flex-grow" name="category_id" v-model="document.category_id" @change="filterSubcategories">
									<option value=""></option>
									<option v-for="category in documents.categories" :key="category.id" :value="category.id">{{ category.name }}</option>
								</select>
							</div>
			    			<div class="flex flex-col mr-4">
			    				<label class="mb-2" for="subcategory_id">Subcategory</label>
								<select class="mt-0 form-select flex-grow" name="subcategory_id" v-model="document.subcategory_id">
									<option v-if="document.category_id == ''" value="">Select a Category</option>
									<option v-if="document.category_id != ''" value=""></option>
									<option v-for="subCategory in subCategories" :key="subCategory.id" :value="subCategory.id">{{ subCategory.name }}</option>
								</select>
							</div>
						</div>
			    	</div>
			    </div>
		    	<div v-if="document.is_image" class="hidden flex py-4">
		    		<div class="flex flex-col w-1/3">
			    		<label class="text-base">Private?</label>
			    		<p class="text-xs leading-normal w-4/5">If turned on this picture will not show up in the Gallery when viewed by third parties.</p>
			    	</div>
			    	<div class="flex-1">
					    <toggle-button v-model="document.is_private" color="#38C172" sync></toggle-button>
			    	</div>
			    </div>
	        </form>
            <div class="bg-gray-100 p-4">
                <div class="text-right">
					<button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
					<button class="btn btn-green" @click.prevent="save">Save Document</button>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

    export default {
        props: ['fileId'],

        data() {
            return {
            	document: '',
            	subCategories: '',
            	csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },

        created() {
        	this.document = _.clone(_.find(this.documents.all, (file) => file.id == this.fileId));
        	this.filterSubcategories();
        },

        computed: {
        	...mapState(['documents']),
        },

        methods: {
            filterSubcategories() {
           		this.subCategories = this.documents.subcategories.filter(subcategory => subcategory.category_id == this.document.category_id);
            },

            save() {
				axios.patch('/documents/' + this.document.id, {
					'document': this.document
				}).then(response => {
                	this.$emit('document-updated', response.data.documents.document);

					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});

					this.hideModal();
                }).catch(error => {
					this.$notify({
						type: 'error',
						title: 'Error',
						text: error.response.data.message
					});
                });
            },
        }
    }
</script>